<template>
  <div id="topbar" :class="{ 'hide-for-countdown': isTrue }" v-show="isTrue">
      <div v-show="(!dataValue?.start?.text && !dataValue?.end?.text) && dataValue?.announcements?.length > 0"  class="topbar-wrapper" :class="{ cs_announ_slide: !isExpired }">
        <AnnouncementBarSlide
          v-if="dataValue?.announcements"
          :data="dataValue?.announcements"
          :check_cny="is_cny_announ"
          @loading-cny="handleLoadingCny"
        />
      </div>
      <div v-show="dataValue?.start?.text || dataValue?.end?.text"  class="topbar-wrapper" :class="{ cs_announ_nomal: isExpired }">
        <AnnouncementBarNormal
          v-if="dataValue?.start || dataValue?.end"
          :start="dataValue?.start?? []"
          :end="dataValue?.end"
          @handleSetisExpired="handleSetisExpired"
          :check_cny="is_cny_countdown"
          @loading-cny="handleLoadingCny"
        />
      </div>
    </div>
</template>

<script lang="ts" setup>
import { ref, computed, onMounted } from "vue";
import AnnouncementBarNormal from "~/components/Header/AnnouncementBarNormal.vue";
import AnnouncementBarSlide from "~/components/Header/AnnouncementBarSlide.vue";
const runtimeConfig = useRuntimeConfig();
const { $file,$ajax } = useNuxtApp();
const userStore = useUserStore();
import { useRoute } from 'vue-router';
import { getCookie } from "@/utils/cookie";
const isExpired = ref(true);
const isTrue = ref<boolean>(true);
const route = useRoute();
const is_cny_announ = ref(false);
const is_cny_countdown = ref(false);

interface CampaignData {
  enable: boolean;
  isCny: boolean;
  enable_cny: boolean;
  announcements: {
    text: string;
    link: {
      title: string;
      url: string;
      target: string;
    };
    class: string;
  };
  start: {
    text: string;
    datetime: string;
    button: {
      title: string;
      url: string;
      target: string;
    };
  };
  end: {
    text: string;
    datetime: string;
    button: {
      title: string;
      url: string;
      target: string;
    };
  };
}
interface IResponse {
  success: boolean;
  data: CampaignData;
};
const dataValue = ref();
const getData = async () => {
  try {
    const { data, error } =  await useAsyncData(
      'topbar',
      async () => {
        return $file.get('topbar.json',
        {
          headers: {
            Authorization: `Bearer ${userStore.csrf}`,
            'X-API-Server': userStore.csrf_server
          }
        });
      }
    );
    const response = data.value as CampaignData;
    dataValue.value = response;
    isExpired.value = response.enable;
     is_cny_announ.value = response?.isCny;
      is_cny_countdown.value = response?.enable_cny;
  }catch (err: any) {
    //console.log('err.response', err);
  }
};
getData();
const handleSetisExpired = () => {
  isExpired.value = false;
  // actionsTopbar();
};
const emit = defineEmits(['loading-cny']);

const handleLoadingCny = (value) => {
  emit('loading-cny', value);
};

onMounted(() => {

  const value = getCookie("topbarClosed");
  isTrue.value = value !== "false";

})

</script>
